"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4145],{

/***/ 34145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionVideoTestimonials": function() { return /* binding */ SectionVideoTestimonials; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30299);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75762);
/* harmony import */ var _VideoTestimonial__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78432);






const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .SectionWrapper */ .Uq, {
    background: "$darkThemeBackground",
    color: "$white",
    variants: {
        spacing: {
            inner: {
                padding: "$20 0"
            },
            outer: {}
        }
    }
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("h2", {
    textAlign: "center",
    marginBottom: "$96",
    padding: "0 $20",
    maxWidth: "1100px",
    marginLeft: "auto",
    marginRight: "auto",
    "@md": {
        marginBottom: "$120"
    },
    variants: {
        appearance: {
            big: {
                projectFont: "heading02"
            },
            small: {
                projectFont: "heading04"
            }
        }
    }
});
const SectionVideoTestimonials = (param)=>{
    let { titleAppearance ="small" , spacing ="inner" , title , slides , priority  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const [currentVideoPlayingIndex, setCurrentVideoPlayingIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // when the view shifts between mobile and desktop, we want to pause videos to prevent double play
        setCurrentVideoPlayingIndex(undefined);
    }, [
        isMd
    ]);
    const handleSlidePlayPause = (videoIndex)=>{
        if (currentVideoPlayingIndex === videoIndex) {
            setCurrentVideoPlayingIndex(undefined);
        } else {
            setCurrentVideoPlayingIndex(videoIndex);
        }
    };
    const handleOnEnded = ()=>{
        setCurrentVideoPlayingIndex(undefined);
    };
    const canHideControlsForVideo = (videoIndex)=>{
        if (currentVideoPlayingIndex === undefined) return false;
        return currentVideoPlayingIndex === videoIndex;
    };
    const handleSlideIntersectionChange = (index, inView)=>{
        if (!inView && index === currentVideoPlayingIndex) {
            setCurrentVideoPlayingIndex(undefined);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: spacing === "inner" ? "NO_MARGIN" : "DEFAULT",
        spacing: spacing,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                appearance: titleAppearance,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Slider */ .iR, {
                isVideo: true,
                children: slides && slides.map((param, index)=>/*#__PURE__*/ {
                    let { personPosition , personName , media , logo  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .InView */ .df, {
                        threshold: 0.6,
                        onChange: (inView)=>handleSlideIntersectionChange(index, inView),
                        children: (param)=>/*#__PURE__*/ {
                            let { inView , ref  } = param;
                            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VideoTestimonial__WEBPACK_IMPORTED_MODULE_4__/* .VideoTestimonial */ .N, {
                                ref: ref,
                                media: media,
                                personName: personName,
                                personPosition: personPosition,
                                logo: logo,
                                priority: priority && index <= 3,
                                play: index === currentVideoPlayingIndex,
                                canHideControlsForVideo: canHideControlsForVideo(index),
                                inView: inView,
                                handleOnEnded: handleOnEnded,
                                handleSlidePlayPause: ()=>{
                                    if (inView) {
                                        handleSlidePlayPause(index);
                                    }
                                },
                                sectionVideos: true
                            });
                        }
                    }, "".concat(index, "-").concat(personName));
                })
            })
        ]
    });
};


/***/ }),

/***/ 78432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ VideoTestimonial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75762);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61349);
/* harmony import */ var _portfolio_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46115);






const hidingAnimation = {
    transition: "transform .7s, opacity .7s",
    variants: {
        hide: {
            true: {
                transform: "translateY(20px)",
                opacity: "0"
            },
            false: {
                transform: "translateY(0)",
                opacity: "1"
            }
        }
    }
};
const Slide = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    color: "$white",
    display: "grid",
    gap: "$32",
    gridTemplateRows: "max-content",
    alignItems: "center",
    cursor: "pointer",
    "-webkit-tap-highlight-color": "transparent",
    variants: {
        inView: {
            false: {
                pointerEvents: "none",
                cursor: "auto"
            }
        }
    }
});
const MediaWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    overflow: "hidden",
    borderRadius: "$r3_mobile",
    "@lg": {
        borderRadius: "$r3"
    },
    transform: "translateZ(0)",
    gridColumn: 1,
    gridRow: 1
});
const ContentWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    alignContent: "flex-end",
    gridColumn: 1,
    gridRow: 1,
    height: "100%",
    paddingBottom: "$32",
    gap: "$24",
    zIndex: "$content",
    overflow: "hidden",
    justifyContent: "center",
    justifyItems: "center",
    borderRadius: "calc($r3_mobile - 1px)",
    "@lg": {
        borderRadius: "calc($r3 - 1px)"
    },
    transform: "translateZ(0)",
    transition: "opacity .7s",
    background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))",
    variants: {
        hide: {
            true: {
                opacity: "0.75"
            },
            false: {
                opacity: "1"
            }
        }
    },
    "@md": {
        gap: "$32"
    }
});
const LogoWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    justifySelf: "center",
    maxWidth: 120,
    "@lg": {
        overflow: "hidden",
        height: 50,
        maxWidth: 180,
        width: "100%"
    },
    ...hidingAnimation
});
const TextWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
    ...hidingAnimation
});
const Name = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center"
});
const Position = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center",
    color: "$white_05"
});
const ControlButton = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    display: "flex",
    margin: "0 auto",
    projectFont: "ui01",
    color: "$white",
    alignItems: "center",
    justifyContent: "center",
    gap: "$8",
    zIndex: "$content",
    "&:focus-visible": {
        outline: "$focusBlue solid 3px;"
    }
});
const VideoTestimonial = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { media , personName , personPosition , logo , play , canHideControlsForVideo , priority , handleOnEnded , handleSlidePlayPause , inView , sectionVideos  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("videoTestimonials");
    const hasMobileVideo = (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" && media.mediaPayload.mobileVideo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Slide, {
        onClickCapture: handleSlidePlayPause,
        ref: ref,
        children: [
            media && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrap, {
                children: (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    disablePlaceholderBackground: true,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    videoOverride: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    },
                    videoOverrideMobile: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && !isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    sizes: "(min-width: 740px) 240px, (min-width: 1000px) 486px, 290px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrap, {
                hide: canHideControlsForVideo,
                children: [
                    sectionVideos && isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                        hide: canHideControlsForVideo,
                        children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                            ...logo,
                            disablePlaceholderBackground: true,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextWrap, {
                        hide: canHideControlsForVideo,
                        children: [
                            personName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                                children: personName
                            }),
                            personPosition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Position, {
                                children: personPosition
                            })
                        ]
                    }),
                    !canHideControlsForVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("play"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Play */ .sh, {})
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("pause"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Pause */ .dz, {})
                        ]
                    })
                ]
            }),
            sectionVideos && !isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                hide: canHideControlsForVideo && isMd,
                children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...logo,
                    disablePlaceholderBackground: true,
                    layout: "intrinsic"
                })
            })
        ]
    });
});


/***/ })

}]);